var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:phone-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 5.25C6.5 4.65326 6.73178 4.08097 7.14437 3.65901C7.55694 3.23705 8.11652 3 8.7 3H15.3C15.8835 3 16.4431 3.23705 16.8556 3.65901C17.2682 4.08097 17.5 4.65326 17.5 5.25V18.75C17.5 19.3467 17.2682 19.919 16.8556 20.341C16.4431 20.7629 15.8835 21 15.3 21H8.7C8.11652 21 7.55694 20.7629 7.14437 20.341C6.73178 19.919 6.5 19.3467 6.5 18.75V5.25ZM13.1 17.625C13.1 17.3266 12.9841 17.0405 12.7778 16.8295C12.5715 16.6185 12.2917 16.5 12 16.5C11.7083 16.5 11.4285 16.6185 11.2222 16.8295C11.0159 17.0405 10.9 17.3266 10.9 17.625C10.9 17.9234 11.0159 18.2095 11.2222 18.4205C11.4285 18.6315 11.7083 18.75 12 18.75C12.2917 18.75 12.5715 18.6315 12.7778 18.4205C12.9841 18.2095 13.1 17.9234 13.1 17.625Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.24f8112fcfd69d80b8673c9c0a7d125f.svg";
export { ForwardRef as ReactComponent };